<template>
  <div class="good-process">
    <Row>
      <Col span="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.title"
                 placeholder="输入标题或商品名..."
                 clearable />
        </FormItem>
        <!-- <FormItem >
                    <Select v-model="formItem.good_id" clearable placeholder="区块链商品" filterable >
                    <Option v-for="goods in goodsList" :key="goods.good_id" :value="goods.good_id" >{{goods.good_title}}</Option>
                </Select>
                </FormItem> -->
        <FormItem>
          <Button type="primary"
                  @click="changePage()">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加生产过程</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading" />
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="添加生产过程"
            v-model="showModalStatus"
            width="60"
            scrollable
            :loading="loading"
            :mask-closable="false"
            closable>
      <Form :model="processDetail"
            ref="processValidate"
            :rules="processValidate"
            action="javascript:void(0)">
        <FormItem label="生产过程标题"
                  prop="title">
          <Input v-model="processDetail.title"
                 placeholder="生产过程输入标题..."></Input>
        </FormItem>
        <FormItem label="区块链商品"
                  prop="good_id">
          <Select v-model="processDetail.good_id"
                  clearable
                  placeholder="区块链商品"
                  filterable
                  @on-change="selectGoods">
            <Option v-for="goods in goodsList"
                    :key="goods.good_id"
                    :value="goods.good_id">{{goods.good_title}}</Option>
          </Select>
        </FormItem>
        <Card v-if="goodsSpec.length>0">
          <FormItem :label="spec.item_name+'：库存'"
                    prop="goods"
                    v-for="spec in goodsSpec">
            <Input v-model="spec.good_store"
                   placeholder="输入库存..."></Input>
          </FormItem>
        </Card>
        <FormItem v-else
                  label="库存"
                  prop="store">
          <Input v-model="processDetail.store"
                 placeholder="输入库存..."></Input>
        </FormItem>
        <FormItem>
          <Button @click="addProduct('processValidate')"
                  type="success"
                  style="margin-top:20px"
                  class="f-r">添加</Button>
          <Button @click="showModalStatus=false"
                  style="margin-top:20px;margin-right:20px"
                  class="f-r">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Drawer title="生产过程详情"
            v-model="showProcessDetail"
            width="60"
            scrollable
            :loading="loading"
            :mask-closable="false"
            closable>
      <Form :model="processDetail"
            ref="processValidate"
            :rules="processValidate"
            action="javascript:void(0)">
        <FormItem label="生产过程标题">
          <Input v-model="processDetail.title"
                 placeholder="生产过程输入标题..."
                 readonly />
        </FormItem>
        <FormItem label="区块链商品"
                  prop="good_id">
          <Select v-model="processDetail.good_id"
                  clearable
                  placeholder="区块链商品"
                  filterable
                  @on-change="selectGoods"
                  disabled>
            <Option v-for="goods in goodsList"
                    :key="goods.good_id"
                    :value="goods.good_id">{{goods.good_title}}</Option>
          </Select>
        </FormItem>
        <Card v-if="goodsSpec.length>0">
          <FormItem :label="spec.item_name+'：库存'"
                    prop="goods"
                    v-for="spec in goodsSpec"
                    :label-width="150">
            <Input v-model="spec.good_store"
                   placeholder="输入库存..."
                   readonly />
          </FormItem>
        </Card>
        <FormItem v-else
                  label="库存"
                  prop="store">
          <Input v-model="processDetail.store"
                 placeholder="输入库存..."
                 readonly />
        </FormItem>

      </Form>
      <Table border
             :columns="columns3"
             ref="selection"
             :data="processDetail.goodcode"
             :loading="dataloading"
             max-height="430" />
      <div class="demo-drawer-footer">
        <Button @click="showProcessDetail=false"
                style="margin-top:20px;margin-right:20px"
                class="f-r">取消</Button>
      </div>
    </Drawer>
    <Drawer :title="selectProduct.title+'-生产记录'"
            v-model="showRecordStatus"
            width="60"
            scrollable
            :loading="loading"
            :mask-closable="false"
            closable>
      <Form :model="recordItem"
            ref="recordItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showRecordModel()"
                  type="success"
                  class="f-r">添加生产记录</Button>
        </FormItem>

      </Form>
      <Table border
             :columns="columns2"
             ref="selection"
             :data="productRecordList"
             :loading="dataloading"
             max-height="500" />
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page ref="recordListPage"
                :total="reocrdPages.total"
                :current="reocrdPages.page"
                :page-size="reocrdPages.size"
                show-elevator
                show-total
                @on-change="changeRecordPage()" />
        </div>
      </div>
      <div class="demo-drawer-footer">
        <Button @click="showRecordStatus=false"
                class="f-r">取消</Button>
      </div>
    </Drawer>
    <Modal v-model="showAddRecordStatus"
           title="添加生产记录"
           @on-ok="createRecord('recordDetailValidate')"
           :loading="loading">
      <Form :model="recordDetail"
            ref="recordDetailValidate"
            :rules="recordDetailValidate"
            action="javascript:void(0)">
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="recordDetail.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="140"
                        :autoCropHeight="80"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:140*80,大小不超过2M'" />
        </FormItem>
        <FormItem label="描述"
                  prop="description">
          <Input v-model="recordDetail.description"
                 placeholder="输入描述..."
                 type="textarea" />
        </FormItem>
        <FormItem label="生产时间"
                  prop="production_at">
          <DatePicker v-model="recordDetail.production_at"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="生产时间"
                      style="width: 200px"
                      type="datetime"
                      @on-change="changeDateOne" />
        </FormItem>
      </Form>
    </Modal>
    <!-- 图片预览 -->
    <viewer :options="viewerOptions"
            :images="codeList"
            @inited="inited"
            class="viewer"
            ref="viewer">
      <template>
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in codeList"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img">
          </div>
        </figure>
      </template>
    </viewer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: 'good-process',
  data () {
    const validateSelectGoods = (rule, value, callback) => {
      if (this.processDetail.good_id === "" || this.processDetail.good_id === null || this.processDetail.good_id === undefined) {
        callback(new Error("请选择商品"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: true,
      formItem: {
        key: ''
      },
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '标题',
          key: 'title',
          fixed: 'left'
        },
        {
          title: '商品名',
          key: 'good.title',
          fixed: 'left',
          render: (h, params) => {
            return h('span', {
            }, params.row.good.title)
          }
        },
        {
          title: '操作',
          key: 'action',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showDetailInfo(params.row)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.getRecordList(params.row)
                  }
                }
              }, '记录')
            ]);
          }
        }
      ],
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },

      processDetail: {
        title: '',
        // sort:0,
      },
      showProcessDetail: false,
      showModalStatus: false,
      showEditInfoStatus: false,
      processValidate: {
        title: { required: true, message: "生产标题必须填写", trigger: "blur" },
        good_id: [
          { required: true, validator: validateSelectGoods, trigger: "change" }
        ]
      },
      goodsList: [],
      goodsSpec: [],
      // 生产记录
      selectProduct: {
        title: ''
      }, // 选中
      showRecordStatus: false,
      productRecordList: [],
      columns2: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '封面图',
          key: 'thumb',
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: params.row.thumb,
                    shape: "square",
                    size: "large"
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: '描述',
          key: 'description',
          render: (h, params) => {
            return h('span', {
            }, params.row.description)
          }
        },
        {
          title: '生产时间',
          key: 'production_at',
        },
      ],
      showAddRecordStatus: false,
      recordDetail: {},
      thumblist: [],
      recordItem: {},
      reocrdPages: {
        page: 1,
        size: 10,
        total: 0
      },
      recordDetailValidate: {
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
        description: [
          { required: true, message: "描述必须填写", trigger: "blur" }
        ],
        production_at: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.recordDetail.production_at == "") {
                callback(new Error("生产时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
      },
      columns3: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '商品码',
          key: 'description',
          render: (h, params) => {
            return h('span', {
            }, params.row.code)
          }
        },
        {
          title: '二维码',
          key: 'thumb',
          render: (h, params) => {
            return h("div", [
              h(
                "img",
                {
                  props: {
                    // src: params.row.qrcode_url,
                    // shape: "square",
                    // size: "large",
                    // click:"showImage"
                  },
                  attrs: {
                    src: params.row.qrcode_url,
                    style: 'width:40px;height:40px'
                  },
                  on: {
                    click: () => {
                      this.showQRCode(params.row.qrcode_url)
                    }
                  }
                },

              )
            ],);
          }
        },
        {
          title: '操作',
          key: 'action',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showQRCode(params.row.qrcode_url)
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.downLoadQRCode(params.row.code, params.row.qrcode_url)
                  }
                }
              }, '下载')
            ]);
          }
        }
      ],
      viewerOptions: {
        toolbar: true,
        url: 'data-source'
      },
      codeList: []
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getGoodsList()
  },
  components: {
    UploadThumb,
  },
  methods: {
    getGoodsList () {
      this.$api.goods.list({
        page: 1,
        size: 999999,
        is_blockchain: '1',
        is_platprice: "0"
      }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.goodsList = res.result.list;
        }
      });
    },
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    getTableList: function () {
      var that = this;
      var params = {
        page: this.pages.page,
        size: this.pages.size
      }
      if (this.formItem.title && this.formItem.title != undefined && this.formItem.title != '') {
        params.key = this.formItem.title
      }
      if (this.formItem.good_id && this.formItem.good_id != undefined && this.formItem.good_id != '') {
        params.good_id = this.formItem.good_id
      }
      this.$api.productprocess.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          that.tablelist = res.result.list;
          that.pages.total = res.result.total
          that.$Message.success(res.msg);
        }
      });
      return;
    },
    selectGoods (value) {
      console.log(value)
      this.getSpecDetail()
    },
    getSpecDetail () {
      if (this.processDetail.good_id == null || this.processDetail.good_id == undefined || this.processDetail.good_id == '') {
        return
      }
      this.$api.productprocess.goodsdetail({ good_id: this.processDetail.good_id }).then(res => {
        this.goodsSpec = res.result.goodspecprice;
        for (let i = 0; i < this.goodsSpec.length; i++) {
          const spec = this.goodsSpec[i];
          spec.good_store = spec.store
        }
      });
    },
    // 展开添加
    showModel () {
      // this.$refs['processValidate'].resetFields();
      this.processDetail = {
        title: ''
      }
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加生产过程
    addProduct (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var old_spec_item = this.goodsSpec

          var params = {
            title: this.processDetail.title,
            good_id: this.processDetail.good_id,
          }
          if (old_spec_item && old_spec_item.length > 0) {
            params.old_spec_item = old_spec_item
          } else {
            if (this.processDetail.store == null || this.processDetail.store == undefined || this.processDetail.store == '' || this.processDetail.store <= 0) {
              this.$Message.error('请输入正确的库存');
              return
            }
            params.store = this.processDetail.store
          }
          this.$api.productprocess.create(params).then(res => {
            if (res.code == 200) {
              this.showModalStatus = false;
              // this.process.name = '';
              this.getTableList();
            }
          });
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    changeRecordPage () {
      this.reocrdPages.page = this.$refs["recordListPage"].currentPage;
      this.getRecordList(this.selectProduct);
    },
    getRecordList (item) {
      var that = this;
      this.selectProduct = item
      that.reocrdPages.pages = 1
      this.$api.productprocess.recordList({ production_id: item.id, page: that.reocrdPages.pages, size: that.reocrdPages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          that.productRecordList = res.result.list;
          that.reocrdPages.total = res.result.total;
          that.$Message.success(res.msg);
          that.showRecordStatus = true
        }
      });
    },
    showRecordModel () {
      this.showAddRecordStatus = true
      this.thumblist = []
      this.recordDetail = {}
    },
    changeDateOne (val) {
      this.goods.lasttime = val;
    },
    createRecord (name) {
      var that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (that.$refs["uploadthumb"].uploadList.length > 0) {
            that.recordDetail.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          }
          this.recordDetail.production_at = this.formatDate(
            this.recordDetail.production_at,
            "yyyy-MM-dd hh:mm:ss"
          );
          that.$api.productprocess.createRecord({ good_id: that.selectProduct.good_id, production_id: that.selectProduct.id, production_at: that.recordDetail.production_at, thumb: that.recordDetail.thumb, description: that.recordDetail.description }).then(res => {
            if (res.code == 200) {
              that.showAddRecordStatus = !this.showAddRecordStatus;
              that.reocrdPages.pages = 1
              that.getRecordList(that.selectProduct)
            }
          });
          that.loading = false
          that.$nextTick(() => { that.loading = true; });
        } else {
          that.$Message.error('请检查输入的信息是否正确！');
          that.loading = false
          that.$nextTick(() => { that.loading = true; });
        }
      })
    },
    //展开修改
    showDetailInfo: function (item) {
      this.processDetail = item;
      this.showProcessDetail = true
      this.goodsSpec = JSON.parse(item.spec_item)
      console.log(this.processDetail)
    },
    showQRCode (qrcode) {
      console.log(111);
      this.codeList = [qrcode]
      console.log(this.codeList)
      this.$viewer.view();
    },
    downLoadQRCode (filename, qrcodeurl) {
      console.log('下载');
      const a = document.createElement('a')
      a.setAttribute('download', filename)
      a.setAttribute('target', '_blank')
      a.setAttribute('href', qrcodeurl)
      a.click()
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.productprocess.remove({ processid: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 初始化viewer
    inited (viewer) {
      console.log('viewer', viewer)
      this.$viewer = viewer
    },
    formatDate (tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  },
}
</script>
<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.viewer-loading > img {
  display: none; /* hide big images when it is loading */
}
</style>